import React, {MouseEvent} from 'react';
import {Button} from 'forms';
import '../../styles/editable.scss';

interface Props {
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const EditButton = ({onClick}: Props) => <Button
    className="edit-btn"
    icon="pencil"
    onClick={onClick}
/>;

export default EditButton;
